import { action, Action } from "easy-peasy";

export interface CartModel {
  orderCart: any;
  addToCart: Action<any, any>;
  editCart: Action<any, any>;
  removeFromCart: Action<any, any>;
  currentItem: any;
  setCurrentItem: Action<any, any>;
  emptyCurrentItem: Action<any, any>;
}

const cart: CartModel = {
  orderCart: { packages: [] },
  currentItem: [],
  addToCart: action((state: any, payload: any) => {
    const {
      printerOwnerId,
      sellerName,
      designThumbnail,
      uploadType,
      postServiceCode,
      postalAddress,
      designId,
      designName,
      printerId,
      printerName,
      quantity,
      files,
      scale,
      infill,
      material,
      designPrice,
      color,
    } = payload;
    let packagesIndex = state.orderCart.packages.findIndex(
      (singlePackage) =>
        singlePackage.requestedForUserId === printerOwnerId &&
        singlePackage.shippingFrom === postServiceCode
    );
    let newCart = state.orderCart;
    const formattedItem = {
      designId,
      designThumbnail,
      designName,
      printerId,
      printerName,
      quantity,
      files,
      scale,
      infill,
      material,
      color,
      uploadType,
      designPrice,
    };
    if (packagesIndex >= 0) {
      newCart.packages[packagesIndex]["items"].push({ ...formattedItem});
    } else {
      let newPackage = {
        requestedForUserId: printerOwnerId,
        sellerName,
        postalAddress,
        orderType: "DESIGN_AND_PRINT",
        deliveryType: "PICKUP",
        shippingFrom: postServiceCode,
        items:[{ ...formattedItem}]
      }
      newCart.packages.push(newPackage);
    }
    state.orderCart = {
      ...state.orderCart,
      ...newCart,
    };
  }),
  removeFromCart: action((state: any, payload: any) => {
    const tempCart = { ...state.orderCart };
    if ((payload.packageIndex || payload.packageIndex === 0) && (payload.itemIndex || payload.itemIndex === 0)) {
      tempCart["packages"][payload.packageIndex]["items"].splice(
        payload.itemIndex,
        1
      );
      if (tempCart["packages"][payload.packageIndex]["items"].length === 0) {
        tempCart["packages"].splice(payload.packageIndex, 1);
      }
    }
    if (payload.packageIndex && !payload.itemIndex) {
      tempCart["packages"].splice(payload.packageIndex, 1);
    }
    state.orderCart = { ...state.orderCart, ...tempCart };
  }),
  editCart: action((state:any, payload:any) => {
    state.orderCart["packages"][payload.packageIndex]["items"][payload.itemIndex] = payload.item;
  }),
  setCurrentItem: action((state: any, payload: any) => {
    state.currentItem = [
      ...payload,
    ];
  }),
  emptyCurrentItem: action((state: any, payload: any) => {
    state.currentItem = [];
  }),
};

export default cart;
